import { Box, Typography } from "@mui/material";
import { FileSVG } from "./FileSVG";
import { styled } from "styled-components";

const InfoBox = styled.div`
  display: flex;
  align-items: flex-start;
  background-color: #e1ecff; /* Light blue background */
  border-radius: 0.75rem; /* 12px */
  padding: 16px;
  gap: 8px;
`;

const IconWrapper = styled.div`
  flex-shrink: 0;
  margin-top: 4px;
`;

const InfoText = styled.div`
  font-size: 14px; /* 14px */
  color: #2d2e32; /* Gray-700 */
  line-height: 20px;

  ul {
    list-style-type: disc;
    padding-left: 1.25rem;
    margin: 0;
  }

  li {
    margin-bottom: 0.5rem;
  }

  li:last-child {
    margin-bottom: 0;
  }

  strong {
    font-weight: 600;
  }
`;

const Methods = ({ setIncome, income }) => {
  return (
    <Box
      sx={() => ({
        marginBottom: "100px",
      })}
    >
      <Typography
        component="p"
        variant="h4"
        textAlign="center"
        marginBottom="40px"
        sx={(theme) => ({
          fontSize: "40px",
          fontWeight: "700",
          lineHeight: "130%",
          [theme.breakpoints.down("sm")]: {
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "32px",
            marginBottom: "24px",
          },
        })}
      >
        Метод подачи заявки
      </Typography>
      <Box
        sx={(theme) => ({
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          maxWidth: "968px",
          margin: "0 auto",
          gap: "24px",
          [theme.breakpoints.down("md")]: {
            margin: "0 16px",
            flexDirection: "column",
          },
        })}
      >
        <Box
          sx={(theme) => ({
            flex: "1",
            minHeight: "260px",
            display: "flex",
            backgroundColor: "#fff",
            padding: "24px",
            border: income ? "4px solid #27AE60" : "4px solid #fff",
            borderRadius: "16px",
            gap: "24px",
            cursor: "pointer",
            textAlign: "left",
            width: "100%",
            [theme.breakpoints.down("md")]: {
              flexDirection: "column",
              gap: "16px",
            },
          })}
          component="button"
          onClick={() => setIncome(true)}
        >
          <Box>
            <Typography
              sx={(theme) => ({
                fontSize: "20px",
                fontWeight: "600",
                lineHeight: "28px",
                marginBottom: "8px",
                [theme.breakpoints.down("sm")]: {},
              })}
            >
              С подтверждением дохода
            </Typography>
            <Typography
              sx={(theme) => ({
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "22px",
                marginBottom: "16px",
                [theme.breakpoints.down("sm")]: {},
              })}
            >
              Потребуется:
            </Typography>
            <ul
              style={{
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                color: "#1C1C1E",
                marginBottom: "8px",
                marginLeft: "25px",
              }}
            >
              <li>ИИН владельца ИП</li>
              <li>Мобильный номер телефона</li>
              <li>
                Справка об оборотах с обслуживающего банка, за последние 12
                месяцев с печатью и подписью уполномоченного лица
              </li>
            </ul>

            <InfoBox>
              <IconWrapper>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.3337 9.99996C18.3337 14.6023 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6023 1.66699 9.99996C1.66699 5.39759 5.39795 1.66663 10.0003 1.66663C14.6027 1.66663 18.3337 5.39759 18.3337 9.99996ZM12.0837 12.9166H10.8337V8.33329H8.33366V9.99996H9.16699V12.9166H7.91699V14.5833H12.0837V12.9166ZM10.0003 7.49996C10.6907 7.49996 11.2503 6.94032 11.2503 6.24996C11.2503 5.5596 10.6907 4.99996 10.0003 4.99996C9.30997 4.99996 8.75033 5.5596 8.75033 6.24996C8.75033 6.94032 9.30997 7.49996 10.0003 7.49996Z"
                    fill="#458AFF"
                  />
                </svg>
              </IconWrapper>

              <InfoText>
                <ul>
                  <li>
                    Перечень необходимых документов:{" "}
                    <strong>
                      К справке об оборотах за последние 12 месяцев необходимо
                      загрузить Выписку об оборотах с того же обслуживающего
                      банка, что и справка, за последние 12 мес.
                    </strong>{" "}
                    Выписка предполагает по-транзакционные обороты клиента по
                    счету.
                  </li>
                  <li>
                    <strong>
                      Выписка об оборотах должна быть неотъемлемой частью
                      справки об оборотах (относится ко всем БВУ).
                    </strong>{" "}
                  </li>
                  <li>
                    <strong>
                      Допускается вложение справок и выписок других БВУ.
                    </strong>
                  </li>
                </ul>
              </InfoText>
            </InfoBox>
          </Box>
        </Box>
        <Box
          component="button"
          onClick={() => setIncome(false)}
          sx={(theme) => ({
            flex: "1",
            minHeight: "256px",
            display: "flex",
            backgroundColor: "#fff",
            padding: "24px",
            borderRadius: "16px",
            textAlign: "left",
            border: !income ? "4px solid #27AE60" : "4px solid #fff",
            gap: "24px",
            cursor: "pointer",
            width: "100%",
            [theme.breakpoints.down("md")]: {
              flexDirection: "column",
              gap: "16px",
            },
          })}
        >
          <Box>
            <Typography
              sx={(theme) => ({
                fontSize: "20px",
                fontWeight: "600",
                lineHeight: "28px",
                marginBottom: "8px",

                [theme.breakpoints.down("sm")]: {},
              })}
            >
              Без подтверждения дохода
            </Typography>
            <Typography
              sx={(theme) => ({
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "22px",
                marginBottom: "16px",
                [theme.breakpoints.down("sm")]: {},
              })}
            >
              Потребуется:
            </Typography>
            <ul
              style={{
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                color: "#1C1C1E",
                marginBottom: "8px",
                marginLeft: "25px",
              }}
            >
              <li>ИИН владельца ИП</li>
              <li>Мобильный номер телефона</li>
              <li>
                Подписать Согласие на сбор данных с Комитета Государственных
                Доходов с ЭЦП НУЦ
              </li>
            </ul>
            <Typography
              sx={(theme) => ({
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                color: "#8B8E99",
                marginLeft: "25px",
                [theme.breakpoints.down("sm")]: {},
              })}
            >
              Это позволит нам принять решение о выдаче займа без прикрепления
              выписок о доходов и иных подтверждений
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Methods;
